import React from "react";
import "./dadosIniciaisPJ.scss";

//Componentes
import Breadcrumbs from "../../components/breadcrumbs";
import NavigationButtons from "../../components/navigationButtons";
import Field from "../../components/field";
import Form from "../../components/form";
import CheckObligation from "../../components/checkObligation";
import Utils from "../../helper/validateUtils";
import { Redirect } from "react-router-dom";
import FieldTelefone from "../../components/fieldTelefone";
//import Typeahead from "../../components/typeahead";
import Loading from "../../components/loading";
import Popover from '../../components/popover';
import iconInfo from '../../assets/images/icon_info.svg';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import VMasker from 'vanilla-masker'

class DadosIniciaisPJ extends React.Component {
  constructor(props) {
    super(props)
    this.state = { buscaCnae: '' }
  }

  componentWillMount() {
    this.formFields = [];
    this.props.configuracaoDdi();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.dadosIniciaisPJ.errorCodigoGerente != nextProps.dadosIniciaisPJ.errorCodigoGerente) {
      var field = this.formFields.dadosIniciais_codigoGerente;
      field.validate(field.input, nextProps.dadosIniciaisPJ.errorCodigoGerente);
    }
    return true;
  }

  render() {
    let {
      formPJ,
      loadingDadosIniciaisCnpj,
      dadosIniciais_CnpjExiste,
      dadosIniciais_codigoGerente,
      dadosIniciais_codigoGerenteViaLink,
      dropdownCNAEList,
      loadingDadosCNAE,
      dadosIniciais_idDDDpais,
      errorCodigoGerente
    } = this.props.dadosIniciaisPJ;

    let {
      changeDadosIniciaisPJValueForm,
      resetDadosIniciaisPJ_NomeGerenteAction,
      getDadosIniciaisPJGerenteAction,
      handleChangeDadosIniciaisPJCNAE,
      getListDadosIniciaisPJCNAEAction,
      setIdDDIPaisDadosIniciaisPJ
    } = this.props;

    const { ddiFixoBrasil, listPais } = this.props.ddiReducer;

    return (
      <section className="container">
        <div className="col">
          <Breadcrumbs title="Dados Iniciais" />
        </div>
        <div className="col">
          <Form name="dadosIniciaisPJ" noValidate={false}>
            <CheckObligation field="dadosIniciais_codigoGerente">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Digite o código do seu gerente"
                    required={validacoes.obrigatorio}
                    label="Código do seu gerente"
                    name="dadosIniciais_codigoGerente"
                    maxlength={6}
                    readOnly={dadosIniciais_codigoGerenteViaLink}
                    value={formPJ.dadosIniciais_codigoGerente}
                    onChange={(field, value) => {
                      changeDadosIniciaisPJValueForm(field, value);
                      resetDadosIniciaisPJ_NomeGerenteAction();

                      if (this.dbcChange != null) {
                        clearInterval(this.dbcChange);
                      }

                      if (value.length > 1) {
                        this.dbcChange = setTimeout(
                          () => getDadosIniciaisPJGerenteAction(value),
                          600
                        );
                      }
                    }}
                    returnObject={this.createRefFields}
                    otherValue={errorCodigoGerente}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation
              field="dadosIniciais_nomeGerente"
              fieldConditional={{
                dadosIniciais_codigoGerente: formPJ.dadosIniciais_codigoGerente,
              }}
            >
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Nome do seu gerente"
                    required={validacoes.obrigatorio}
                    label="Nome do seu gerente"
                    name="dadosIniciais_nomeGerente"
                    maxlength={50}
                    value={formPJ.dadosIniciais_nomeGerente}
                    onChange={changeDadosIniciaisPJValueForm}
                    returnObject={this.createRefFields}
                    loading={formPJ.loadingDadosGerente}
                    readOnly
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_razaoSocial">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Digite sua Razão Social"
                    required={validacoes.obrigatorio}
                    label="Razão Social"
                    name="dadosIniciais_razaoSocial"
                    minlength={3}
                    maxlength={100}
                    value={formPJ.dadosIniciais_razaoSocial}
                    onChange={changeDadosIniciaisPJValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>
            <CheckObligation field="dadosIniciais_cnpj">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="number"
                    required={validacoes.obrigatorio}
                    label="CNPJ"
                    name="dadosIniciais_cnpj"
                    mask="99.999.999/9999-99"
                    value={formPJ.dadosIniciais_cnpj}
                    validateSync={Utils.isCNPJ}
                    onChange={changeDadosIniciaisPJValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>
            <CheckObligation field="dadosIniciais_cnae">
              {(validacoes) => (
              <>
                <div className="col-95">
                  <Autocomplete
                    options={dropdownCNAEList}
                    value={formPJ.dadosIniciais_cnae}
                    id="dadosIniciais_cnae"
                    noOptionsText="Sem resultados"
                    getOptionLabel={(option) => option.Id ? option.Codigo + " " + option.Descricao : ''}
                    onChange={(ev, newValue) => {
                      this.setState({
                        buscaCnae: newValue ? newValue.Codigo + " " + newValue.Descricao : ''
                      });
                      handleChangeDadosIniciaisPJCNAE(newValue)}
                    }
                    blurOnSelect
                    loading={loadingDadosCNAE}
                    loadingText="Buscando CNAE"
                    inputValue={this.state.buscaCnae}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        type="text"
                        required={validacoes.obrigatorio}
                        label="Atividade da Empresa"
                        name="dadosIniciais_cnae"
                        onChange={({ target: { value }}) => {
                          let maskedValue = this.maskCodigoCnae(value);
                          this.setState({ buscaCnae: maskedValue });
                          getListDadosIniciaisPJCNAEAction(maskedValue).then(loadingDadosCNAE);
                        }
                        }
                        onFocus={({ target: { value }}) =>
                          getListDadosIniciaisPJCNAEAction(this.maskCodigoCnae(value)).then(loadingDadosCNAE)
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingDadosCNAE ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </div>
                <div className="col-5">
                  <Popover message="Consta informação no Cartão do CNPJ - CNAE Principal" icon={iconInfo} />
                </div>
              </>
              )}
            </CheckObligation>
            <CheckObligation field="dadosIniciais_nomeContato">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="text"
                    placeholder="Digite o nome da Pessoa de contato"
                    required={validacoes.obrigatorio}
                    label="Nome da Pessoa de contato"
                    name="dadosIniciais_nomeContato"
                    minlength={6}
                    maxlength={50}
                    value={formPJ.dadosIniciais_nomeContato}
                    onChange={changeDadosIniciaisPJValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>

            <CheckObligation field="dadosIniciais_cpfContato">
              {(validacoes) => (
                <div className="col-50">
                  <Field
                    type="cpf"
                    placeholder="999.999.999-99"
                    required={validacoes.obrigatorio}
                    label="CPF do Contato"
                    name="dadosIniciais_cpfContato"
                    mask="999.999.999-99"
                    pattern="^\d{3}\x2E\d{3}\x2E\d{3}\x2D\d{2}$"
                    validateSync={Utils.isCPF}
                    value={formPJ.dadosIniciais_cpfContato}
                    onChange={changeDadosIniciaisPJValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>

            <div className="col-50">
              <CheckObligation field="dadosIniciais_ddiTelefoneContato">
                {(validacoes) => (
                  <div className="col-20 p-0">
                    <FieldTelefone
                      type="ddi"
                      placeholder="+999"
                      required={validacoes.obrigatorio}
                      label="DDI"
                      name="dadosIniciais_ddiTelefoneContato"
                      value={ddiFixoBrasil ? "+55" : formPJ.dadosIniciais_ddiTelefoneContato}
                      maxlength={5}
                      onChange={changeDadosIniciaisPJValueForm}
                      returnObject={this.createRefFields}
                      idDDIpais={dadosIniciais_idDDDpais}
                      onChangeDDI={setIdDDIPaisDadosIniciaisPJ}
                      readOnly={ddiFixoBrasil}
                      selectToogle={!ddiFixoBrasil}
                      listPais={listPais.filter(x => x.DDI !== null)}
                    />
                  </div>
                )}
              </CheckObligation>

              <CheckObligation field="dadosIniciais_telefoneContato">
                {(validacoes) => (
                  <div className="col-70 p-0">
                    <FieldTelefone
                      type="cel"
                      placeholder="(99)99999-9999"
                      required={validacoes.obrigatorio}
                      label="Telefone Celular (DDD + Número)"
                      name="dadosIniciais_telefoneContato"
                      value={formPJ.dadosIniciais_telefoneContato}
                      mask="99999999999999999999"
                      maxlength={20 - formPJ.dadosIniciais_ddiTelefoneContato.replace("+", "").length}
                      onChange={changeDadosIniciaisPJValueForm}
                      returnObject={this.createRefFields}
                      ddiForMask={formPJ.dadosIniciais_ddiTelefoneContato}
                    />
                  </div>
                )}
              </CheckObligation>
            </div>

            <CheckObligation field="dadosIniciais_emailContato">
              {(validacoes) => (
                <div className="col">
                  <Field
                    type="email"
                    maxlength={100}
                    placeholder="Digite seu e-mail"
                    required={validacoes.obrigatorio}
                    label="E-mail"
                    name="dadosIniciais_emailContato"
                    value={formPJ.dadosIniciais_emailContato}
                    onChange={changeDadosIniciaisPJValueForm}
                    returnObject={this.createRefFields}
                  />
                </div>
              )}
            </CheckObligation>
          </Form>
        </div>
        <div className="col">
          <NavigationButtons
            history={this.props.history}
            modal={!formPJ.dadosIniciais_codigoGerente}
            validateFields={this.validateFields}
            disabledProx={loadingDadosIniciaisCnpj}
          />
          {/* {dadosIniciais_CnpjExiste && <Redirect to="/conclusao" />} */}
        </div>
      </section>
    );
  }

  maskCodigoCnae = (value) => {
    if (value.length > 6) return value;

    if (/^[0-9]{2}\.[0-9]([0-9]-[0-9])?$/.test(value))
      return value;

    if (/[^\d.-]/.test(value))
      return value;
    
    return VMasker.toPattern(value, '99.99-9');
  };

  createRefFields = (self) => {
    this.formFields[self.props.name] = self;
  };

  validateFields = async () => {
    let list = [];
    let { dadosIniciais_cnpj } = this.props.dadosIniciaisPJ.formPJ;

    if (dadosIniciais_cnpj) {
      await this.props.getDadosIniciaisExisteCnpjAction(
        dadosIniciais_cnpj
      );
    }

    return new Promise((resolve) => {
      for (let key in this.formFields) {
        if (this.formFields[key]._isMounted)
          this.formFields[key]
            .validate(this.formFields[key].input)
            .then((r) => {
              list.push({ name: this.formFields[key].props.name, valid: r });
              if (Object.keys(this.formFields).length === list.length)
                resolve(list);
            });
      }
    });
  };
}

export default DadosIniciaisPJ;